import { render, staticRenderFns } from "./SchoolAccountTerms.vue?vue&type=template&id=e1a6d39a&"
var script = {}
import style0 from "./SchoolAccountTerms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports